export const iconFontAwesomeMedicalHealthVirusSlash = (
	<i className="fa-solid fa-virus-slash"></i>
);
